<section class="relative w-full overflow-hidden -z-10">
    <div class="relative px-0">
        <div class="carousel-inner  overflow-hidden relative mt-6">
            <div *ngFor="let slide of slides; let i = index"
                 class="carousel-item  absolute -z-10 inset-0 transition-opacity duration-1000"
                 [ngClass]="{'opacity-100': i === currentIndex, 'opacity-0': i !== currentIndex}">
                <div class="item bg-cover bg-center bg-no-repeat pt-6 pb-10 py-16 h-full relative"
                     [ngStyle]="{'background-image': 'url(' + slide.imgSrc + ')'}">
                    <!-- Black overlay layer -->
                    <div class="bg-black absolute inset-0 opacity-30 z-0"></div>

                    <div class="container mx-auto flex items-center h-full pt-6 pt-md-0 relative z-10">
                        <div class="flex items-center ">
                            <div class="w-full relative md:w-[70%]">
                                <h1 class="text-2xl ms-2 lg:text-5xl font-bold mb-2 md:mb-10 text-white ">{{ slide.title }}</h1>
                                <div class="lg:flex items-center">
                                    <div class="ms-3  lg:ms-0 h-[15px] w-[60px] bg-white "></div>
                                    <div class="ps-3 ">
                                        <p class=" text-lg text-white">{{ slide.description }}</p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<div class="container pt-6">
    <div class="card shadow mx-auto p-5 w-full flex align-middle">
        <div class="w-[4%] text-2xl bg-[#090A75] text-white flex items-center justify-center">
            <i class="fa fa-search"></i>
        </div>
        <div class="w-[76%] bg-[#090A75] flex align-middle">
            <input type="text" placeholder="Search Programs" class="outline-0 py-3 bg-transparent text-white font-bold">
        </div>
        <div class="w-[20%] bg-black">
            <button class="bg-black text-white p-5 w-full font-bold">Search</button>
        </div>
    </div>
    <div class="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-12 gap-5 mt-4">
        <div class="sm:col-span-1 md:col-span-1 lg:col-span-4 xl:col-span-3 " *ngFor="let img of programImages">
            <div class="img-box">
                <img [src]="img.img" alt="">
                <div class="bg-gray-300 w-full h-full flex items-center justify-center upper-layer">
                    <div>
                        <h4 class="mx-6 text-2xl mb-4 text-white font-bold">{{ img.title }}</h4>
                                                <a class="img-box-btn px-5 py-3 font-bold text-white text-[12px]">Learn
                                                    More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="grid md:grid-cols-2 gap-1 my-6 py-4">
        <div class="md:col-span-1 self-center">
            <h6 class="text-2xl">Take Charge of Your Future with International Career Opportunities and French Ministry
                of
                Higher Education International Programs!</h6>
            <iframe class="w-[100%] my-3" height="343" src="https://www.youtube.com/embed/Pe5KA8C2fB8"
                    title="Welcome to Paris American Institute" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div class="md:col-span-1 md:p-5 text-justify py-3">
            <p>Welcome to Paris American International University’s India office website in partnership with the Education Mitra
                India, your gateway to premier online degree courses in the India, where
                international
                recognition meets innovation in the heart of India. As a renowned institution bearing the esteemed
                recognition of
                the French Ministry of Higher Education, we offer a unique blend of university-level education and
                learning
                excellence. Our India recognized French degrees open a world of opportunities, ensuring you receive a
                globally
                accredited education right from the comfort of your home. At PAIU, we are more than just an academic
                institution; we are a community supported by the French Ministry Accredited University, dedicated to
                providing
                you with a seamless, engaging learning experience. Commence your journey with us today and take
                advantage of our
                exceptional online programs to reach new heights in your career.
            </p>
            <p class="my-3">
                We believe in delivering quality education tailored for today’s competitive world. Our academic programs
                are
                designed to prepare students for successful careers, offering a broad range of undergraduate and
                postgraduate
                degrees that meet international standards. As a French Ministry of Higher Education International
                Program, our
                focus is on providing flexible and innovative learning opportunities for students across the globe,
                especially
                for working professionals and those looking to advance their careers.
            </p>
            <p>
                Join the success journey and become a proud alumnus of PAI University.
            </p>
            <button
                class=" w-full md:w-auto my-6 bg-gray-900 transition-all duration-300 hover:bg-[#36348E] px-5 py-3 font-bold text-white text-[16px]"
                [routerLink]="'/about-us'">Learn More <i class="fa fa-arrow-right ms-1"></i>
            </button>
        </div>
    </div>
</div>
<div class="bg-gray-200 py-[50px]">
    <div class="container mx-auto">
        <h2 class=" text-3xl pb-3 font-bold text-center ">Limitless Learning Opportunities with PAIU, What Sets Us
            Apart</h2>
        <div class="grid sm:grid-cols-2 md:grid-cols-12 gap-5 mt-4">
            <div class="sm:col-span-1 md:col-span-4 card shadow-slate-100 rounded bg-white text-black"
                 *ngFor="let item of learning">
                <div class="p-6">
                    <i [ngClass]="item.icon" class="text-blue-500 text-4xl"></i>
                    <h3 class="text-[15px] font-bold text-black mt-2  ">{{ item?.title }}</h3>
                    <p class="my-2 text-[14px] leading-6">{{ item.content }}</p>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="bg-[#36348E]">
    <div class="container mx-auto flex flex-wrap justify-center py-5 gap-5">
        <div class="bg-[#f9f9f9] w-[33%] md:w-[22%] ">
            <img class="md:h-[130px] w-full" src="assets/image/acr-01-1.jpg.bv.webp" alt="">
        </div>
        <div class="bg-white w-[33%] md:w-[22%] ">
            <img class="md:h-[130px] w-full" src="assets/image/france-acc-300x177.png.bv.webp" alt="">
        </div>
        <div class="bg-white w-[33%] md:w-[22%] ">
            <img class="md:h-[130px] w-full" src="assets/image/Qualiopi_processus_certifie.png.bv.webp" alt="">
        </div>
        <button class="underline text-white text-xl ms-5">View All</button>
    </div>
</div>
<div class="py-5">
    <div class="container mx-auto py-5">
        <h2 class="font-bold text-3xl text-gray-900 py-5">Trending Programs in High Demand</h2>
    </div>
    <div class="container mx-auto grid md:grid-cols-2 lg:grid-cols-12 justify-center gap-1">
        <div class="flip-card w-[325px]  md:w-[95%] h-[350px] md:col-span-1 lg:col-span-3 " tabIndex="0">
            <div class="flip-card-inner bg-transparent">
                <div class="flip-card-front -z-10 flex flex-wrap justify-center items-center">
                    <div class=" ">
                        <img src="assets/image/data-science.png" class="w-1/2 mx-auto" alt="">
                    </div>
                    <h3 class="font-bold">Data Science Degree</h3>
                </div>
                <div class="flip-card-back -z-10 p-4">
                    <p>Become a data-driven professional and take advantage of the growing demand for data scientists
                        worldwide. Our Bachelors in Data Science is crafted for the modern digital economy.</p>
                </div>
            </div>
        </div>
        <div class="flip-card w-[325px]  md:w-[95%] h-[350px] md:col-span-1 lg:col-span-3 " tabIndex="0">
            <div class="flip-card-inner  bg-transparent">
                <div class="flip-card-front -z-10 flex flex-wrap justify-center items-center">
                    <div class=" ">
                        <img src="assets/image/investment.png" class="w-1/2 mx-auto" alt="">
                    </div>
                    <h3 class="font-bold">Business Management</h3>
                </div>
                <div class="flip-card-back -z-10 p-4">
                    <p>Advance your management skills with our Online Degree, perfect for those looking to excel in
                        business
                        administration with a global perspective.</p>
                </div>
            </div>
        </div>
        <div class="flip-card w-[325px]  md:w-[95%] h-[350px] md:col-span-1 lg:col-span-3 " tabIndex="0">
            <div class="flip-card-inner bg-transparent">
                <div class="flip-card-front -z-10 flex flex-wrap justify-center items-center">
                    <div class=" ">
                        <img src="assets/image/hack.png" class="w-1/2 mx-auto" alt="">
                    </div>
                    <h3 class="font-bold">Cyber Security Program</h3>
                </div>
                <div class="flip-card-back -z-10 p-4">
                    <p>Cybersecurity professionals are in high demand. Gain cutting-edge skills with our Bachelor’s &
                        Master’s in
                        Cyber Security program, which provides a deep dive into protecting digital infrastructures.</p>
                </div>
            </div>
        </div>
        <div class="flip-card w-[325px]  md:w-[95%] h-[350px] md:col-span-1 lg:col-span-3 " tabIndex="0">
            <div class="flip-card-inner bg-transparent">
                <div class="flip-card-front -z-10 flex flex-wrap justify-center items-center">
                    <div class=" ">
                        <img src="assets/image/restaurant.png" class="w-1/2 mx-auto" alt="">
                    </div>
                    <h3 class="font-bold">Hospitality Management Degree</h3>
                </div>
                <div class="flip-card-back -z-10 p-4">
                    <p>Take your hospitality career to the next level with our comprehensive Bachelor of Hospitality
                        Management
                        program, designed for the global tourism and hotel management industry.</p>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="container mx-auto">
    <div class="grid md:grid-cols-2 gap-1 my-6 py-4">
        <div class="md:col-span-1 self-center">
            <h2 class="text-2xl font-bold">Campus Recognition in the India</h2>
            <iframe class="w-[100%] my-3" height="343" src="https://www.youtube.com/embed/A5W4axVRcVY"
                    title="Paris American Institute"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            <p>
                In the heart of the India, a beacon of academic excellence and innovation stands out: PAIU, renowned for
                offering
                French Accredited degrees. Our diverse array of programs, from Bachelor’s to Doctorate degrees, are
                meticulously
                designed to meet the highest standards of French higher education, ensuring that each course not only
                enlightens
                but empowers our students.
            </p>
            <p>
                At PAIU, we take pride in our partnership with the French Ministry of Higher Education, a collaboration
                that
                guarantees international recognition for our students. Whether you’re pursuing an undergraduate degree
                or
                delving into the depths of postgraduate study, our offerings are crafted to provide a comprehensive
                education
                that transcends borders. Our Master’s programs in India, underscored by the rigorous French Curriculum,
                are
                tailored for both local and international students aiming for excellence in their chosen fields.
            </p>
        </div>
        <div class="md:col-span-1 md:p-5 text-justify py-3 self-center">
            <p>To verify PAIU, visit French Ministry of Higher Education Database and search PAI University
            </p>
            <p class="my-3">
                PAIU program authorizations:
            </p>

            <a href="" class="cursor-pointer"> Bachelor Of Business Administration (BBA) ->
            </a>
            <br>
            <a href="" class="cursor-pointer">
                Master Of Business Administration (BBA) ->
            </a>
            <p>
                PAI University is certified by Qualifi which is a recognised UK awarding organisation regulated in
                England by
                the Office of Qualifications and Examinations Regulation (Ofqual).
            </p>
            <br>
            <a href="" class="cursor-pointer">
                Ph.D In Business Administration ->
            </a>
            <p>
                Our commitment to providing top-tier education is evident through our French Ministry Accredited
                university
                status and our affiliation with French accredited universities in the India. This prestigious
                accreditation
                ensures that our online degree courses in India are not only recognized locally but are also esteemed on a
                global
                scale.
            </p>
        </div>
    </div>

</div>
<div class="container mx-auto">
    <h2 class="text-2xl font-bold">Our Programs Suitable for</h2>
    <div class="my-2">
        <div class="flex border-b bg-[#ced4fb] justify-between border-gray-300">
            <button
                *ngFor="let tab of tabs; let i = index"
                class="py-2 font-bold w-full px-1 text-[14px]  focus:outline-none focus:text-[#36348E] hover:text-[#36348E] transition duration-150"
                [class.active]="activeTab === i"
                (click)="selectTab(i)"
            >
                {{ tab.label }}
            </button>
        </div>
        <div class="border-t-0 border p-4">
            <div *ngFor="let tab of tabs; let i = index">
                <p *ngIf="activeTab === i" class="text-[14px]">
                    {{ tab.content }}
                </p>
            </div>
        </div>
    </div>
</div>

<div class="container mx-auto py-6">
    <h2 class="text-2xl font-bold pt-5">Blogs</h2>
    <div class="my-2">
        <div class="grid md:grid-cols-6 gap-2 md:h-[580px] overflow-y-hidden   justify-between">
            <div class="col-span-12 md:col-span-2 p-5">
                <div>
                    <img src="assets/image/best-online-colleges-for-information-technology-UAE-scaled.webp" alt="">
                </div>
                <div class="p-4 hover:bg-amber-400 h-[55%]">
                    <h3 class="font-bold text-lg">
                        5 Essential Steps to Become an IT Specialist and Land Your Dream Job
                    </h3>
                    <small class="text-[10px] text-gray-600">20 jan 2025</small>
                    <p class="text-[14px] text-gray-500">
                        Finding your career will help you focus your learning efforts and guide your career path.
                        Consider what excites you the most about technology—whether it’s problem-solving, creativity in
                        coding, or ensuring network security—and use that as a compass for your professional journey.
                    </p>
                </div>
            </div>
            <div class="col-span-12 md:col-span-2 p-5">
                <div>
                    <img src="assets/image/Online-Masters-Degree-UAE-scaled.jpg.bv.webp" alt="">
                </div>
                <div class="p-4 hover:bg-amber-400 h-[55%]">
                    <h3 class="font-bold text-lg">
                        How to Secure a Job in the India After Completing Your Master’s Program </h3>
                    <small class="text-[10px] text-gray-600">20 jan 2025</small>
                    <p class="text-[14px] text-gray-500">
                        How to get your dream job in the India after your Master’s program, this guide will walk you
                        through the key strategies that make you stand out and be successful.
                    </p>
                </div>
            </div>
            <div class="col-span-12 md:col-span-2 p-5">
                <div>
                    <img src="assets/image/Professional-Doctorate-in-Business-Administration-UAE-scaled.webp" alt="">

                </div>
                <div class="p-4 hover:bg-amber-400 h-[55%]">
                    <h3 class="font-bold text-lg">
                        What to Expect: Career Opportunities for DBA Graduates in the India </h3>
                    <small class="text-[10px] text-gray-600">20 jan 2025</small>
                    <p class="text-[14px] text-gray-500">
                        A Doctorate in Business Administration (DBA) represents the pinnacle of academic achievement in
                        the field of business, providing graduates with the knowledge and skills necessary to navigate
                        complex business environments. This advanced degree not only signifies a deep understanding of
                        business theory and practices but also demonstrates a commitment to lifelong learning and
                        professional development.
                    </p>
                </div>
            </div>
        </div>
        <div class="md:flex justify-end">
            <button class="underline text primary-color font-bold">Read More..</button>

        </div>
    </div>
</div>

<section class="container mx-auto py-6">
    <h2 class="text-2xl font-bold py-5">Benefits of Online Mode Students and Offline Mode Students
    </h2>
    <div class="w-full overflow-x-auto">
        <table class="table-auto w-full min-w-[1000px] border-collapse">
            <thead class="bg-[#36348E] text-white">
            <tr>
                <th class="border text-start px-6 py-5 text-xl">Benefits</th>
                <th class="border text-start px-6 py-5 text-xl">Online Students</th>
                <th class="border text-start px-6 py-5 text-xl">Offline Students</th>
            </tr>
            </thead>
            <tbody>
            <tr class="border">
                <td class="font-bold p-6">Flexibility</td>
                <td class="px-6">Study at your own pace and schedule</td>
                <td class="px-6">Structured timetable with in-person classes</td>
            </tr>
            <tr class="border">
                <td class="font-bold p-6">Accessibility</td>
                <td class="px-6">Access course materials from anywhere in the world</td>
                <td class="px-6">Access to campus facilities and resources</td>
            </tr>
            <tr class="border">
                <td class="font-bold p-6">Interaction</td>
                <td class="px-6">Online forums and virtual collaboration tools</td>
                <td class="px-6">Face-to-face interaction with peers and faculty</td>
            </tr>
            <tr class="border">
                <td class="font-bold text-nowrap p-6">Learning Environment</td>
                <td class="px-6">Learn in a comfortable and familiar environment</td>
                <td class="px-6">Immersive campus experience</td>
            </tr>
            <tr class="border">
                <td class="font-bold text-nowrap p-6">Technology Integration</td>
                <td class="px-6">Use of advanced online learning platforms and tools</td>
                <td class="px-6">Hands-on experience with campus technology and laboratories</td>
            </tr>
            <tr class="border">
                <td class="font-bold text-nowrap p-6">Networking Opportunities</td>
                <td class="px-6">Connect with an online community</td>
                <td class="px-6">Engage in on-campus events, clubs, and activities</td>
            </tr>
            <tr class="border">
                <td class="font-bold text-nowrap p-6">Cost-Efficiency</td>
                <td class="px-6">Save on travel and accommodation costs</td>
                <td class="px-6">Access to campus amenities such as libraries, sports facilities, and study spaces</td>
            </tr>
            <tr class="border">
                <td class="font-bold text-nowrap p-6">Support Services</td>
                <td class="px-6">Online academic and technical support</td>
                <td class="px-6">In-person support from faculty and campus services</td>
            </tr>
            <tr class="border">
                <td class="font-bold text-nowrap p-6">Work-Life Balance</td>
                <td class="px-6">Balance studies with work and personal commitments</td>
                <td class="px-6">Dedicated study environment with fewer home distractions</td>
            </tr>
            <tr class="border">
                <td class="font-bold text-nowrap p-6">Practical Experience</td>
                <td class="px-6">Online projects and simulations</td>
                <td class="px-6">Real-world practical experiences through internships and campus-based projects</td>
            </tr>
            <tr class="border">
                <td class="font-bold p-6">Student Assistance</td>
                <td class="px-6">Career counseling, job search resources, and virtual career workshops</td>
                <td class="px-6">One-on-one career counseling, resume workshops, job fairs</td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="space-y-4  mx-auto mt-8 w-full">
        <h2 class="text-3xl mx-auto font-bold py-5">Frequently Asked Questions
        </h2>
        <div *ngFor="let item of accordionItems; let i = index" class="border  overflow-hidden">
            <button
                (click)="toggleAccordion(i)"
                class="w-full flex justify-between items-center px-4 py-3 text-left font-semibold text-white bg-[#36348E] hover:bg-gray-200 hover:text-[#36348E] focus:outline-none transition">
                <span>{{ item.title }}</span>
                <svg
                    [class.transform]="item.open"
                    [class.rotate-180]="item.open"
                    xmlns="http://www.w3.org/2000/svg"
                    class="w-4 h-4 transition-transform duration-300 ease-in-out"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
                </svg>
            </button>
            <div
                [class.max-h-0]="!item.open"
                [class.max-h-[500px]]="item.open"
                class="overflow-hidden transition-all duration-500 ease-in-out bg-white"
            >
                <div class="px-4 py-3 text-gray-600">
                    {{ item.content }}
                </div>
            </div>
        </div>
    </div>
</section>
<section class="bg-[#b7d8ef] mt-52">
    <div class="w-[90%] md:w-[90%] flex xl:w-[70%] mx-auto pt-6">
        <div class="w-1/2 py-20">
            <p class="font-bold">Our affiliation with the French Ministry of Higher Education means you receive an education that's not
                just comprehensive but also globally acclaimed. Are you ready to start learning from the world’s best
                online education university? Questions?</p>
        </div>
        <div class="w-1/2 flex items-center justify-end relative">
            <img src="assets/image/footer_woman2-e1607543467282-testDamyan-2.jpg.bv.webp" class="absolute left-0 top-[-88%] w-1/2" alt="">
            <button class="bg-black text-white p-5 w-1/3 hover:bg-[#36348E] font-bold" [routerLink]="'contact-us'">
                Contact Us
            </button>

        </div>
    </div>
</section>


